import { inlineMarkdownToSafeHtml } from '../utils/inlineMarkdown';

type Props = {
  text: string;
  className?: string;
  as?: 'p' | 'span';
};

/** Escaped HTML + `**bold**` from trusted CMS copy */
export function RichInlineMd(props: Props) {
  const Tag = props.as ?? 'p';
  const cls = props.className ? `wi-rich-md ${props.className}`.trim() : 'wi-rich-md';
  return (
    <Tag
      className={cls}
      // eslint-disable-next-line react/no-danger -- escaped; **bold** only
      dangerouslySetInnerHTML={{ __html: inlineMarkdownToSafeHtml(props.text) }}
    />
  );
}
